import { OnMutateHighlightsT, OnUpdateHighlightsT } from '../types';

export enum HighlightOperationEnum {
  CREAT = 'create',
  UPDATE = 'update',
}

export type HighlightTooltipProps =
  | {
      onMutateHighlight: (data: OnMutateHighlightsT) => void;
      highlightOperation: HighlightOperationEnum.CREAT;
    }
  | {
      onMutateHighlight: (data: OnUpdateHighlightsT) => void;
      highlightOperation: HighlightOperationEnum.UPDATE;
    };
